export const SvgHamburger: React.FC<
  { toLeft?: boolean; toRight?: never } | { toLeft?: never; toRight?: boolean }
> = ({ toLeft, toRight }) => {
  let dataIcon = "hamburger";
  if (toLeft) {
    dataIcon = "hamburgertoleft";
  }
  if (toRight) {
    dataIcon = "hamburgertoright";
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      data-icon={dataIcon}
      fill="currentColor"
    >
      <rect x="3" y="4" width="14" height="2"></rect>
      <rect x="3" y="9" width="14" height="2"></rect>
      <rect x="3" y="14" width="14" height="2"></rect>
    </svg>
  );
};

export const SvgHamburgerToRight: React.FC = () => {
  return <SvgHamburger toRight={true} />;
};

export const SvgHamburgerToLeft: React.FC = () => {
  return <SvgHamburger toLeft={true} />;
};

export const SvgPlus: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 20 20"
      data-icon="plus"
      fill="currentColor"
    >
      <rect x="9" y="3" width="2" height="14" />
      <rect x="3" y="9" width="14" height="2" />
    </svg>
  );
};

export const SvgMinus: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      data-icon="plus"
      fill="currentColor"
    >
      <rect x="3" y="9" width="14" height="2" />
      <rect x="3" y="9" width="14" height="2" />
    </svg>
  );
};

export const SvgPlusx: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      data-icon="plus-x"
      fill="currentColor"
    >
      <rect x="2" y="7" width="12" height="2" />
      <rect x="2" y="7" width="12" height="2" />
    </svg>
  );
};

export const SvgLoader: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      width="16"
      height="16"
    >
      <g>
        <g transform="rotate(0 50 50)">
          <rect
            x="44"
            y="-0.5"
            rx="2.52"
            ry="2.52"
            width="12"
            height="21"
            fill="currentColor"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.9166666666666666s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(30 50 50)">
          <rect
            x="44"
            y="-0.5"
            rx="2.52"
            ry="2.52"
            width="12"
            height="21"
            fill="currentColor"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.8333333333333334s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(60 50 50)">
          <rect
            x="44"
            y="-0.5"
            rx="2.52"
            ry="2.52"
            width="12"
            height="21"
            fill="currentColor"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.75s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(90 50 50)">
          <rect
            x="44"
            y="-0.5"
            rx="2.52"
            ry="2.52"
            width="12"
            height="21"
            fill="currentColor"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.6666666666666666s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(120 50 50)">
          <rect
            x="44"
            y="-0.5"
            rx="2.52"
            ry="2.52"
            width="12"
            height="21"
            fill="currentColor"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.5833333333333334s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(150 50 50)">
          <rect
            x="44"
            y="-0.5"
            rx="2.52"
            ry="2.52"
            width="12"
            height="21"
            fill="currentColor"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.5s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(180 50 50)">
          <rect
            x="44"
            y="-0.5"
            rx="2.52"
            ry="2.52"
            width="12"
            height="21"
            fill="currentColor"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.4166666666666667s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(210 50 50)">
          <rect
            x="44"
            y="-0.5"
            rx="2.52"
            ry="2.52"
            width="12"
            height="21"
            fill="currentColor"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.3333333333333333s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(240 50 50)">
          <rect
            x="44"
            y="-0.5"
            rx="2.52"
            ry="2.52"
            width="12"
            height="21"
            fill="currentColor"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.25s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(270 50 50)">
          <rect
            x="44"
            y="-0.5"
            rx="2.52"
            ry="2.52"
            width="12"
            height="21"
            fill="currentColor"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.16666666666666666s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(300 50 50)">
          <rect
            x="44"
            y="-0.5"
            rx="2.52"
            ry="2.52"
            width="12"
            height="21"
            fill="currentColor"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.08333333333333333s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g transform="rotate(330 50 50)">
          <rect
            x="44"
            y="-0.5"
            rx="2.52"
            ry="2.52"
            width="12"
            height="21"
            fill="currentColor"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="0s"
              repeatCount="indefinite"
            />
          </rect>
        </g>
        <g />
      </g>
    </svg>
  );
};

export const SvgLoaderCircle: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <g>
        <circle
          cx="12"
          cy="12"
          r="9.5"
          fill="none"
          strokeWidth="3"
          strokeLinecap="round"
        >
          <animate
            attributeName="stroke-dasharray"
            dur="1.5s"
            calcMode="spline"
            values="0 150;42 150;42 150;42 150"
            keyTimes="0;0.475;0.95;1"
            keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-dashoffset"
            dur="1.5s"
            calcMode="spline"
            values="0;-16;-59;-59"
            keyTimes="0;0.475;0.95;1"
            keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1"
            repeatCount="indefinite"
          />
        </circle>
        <animateTransform
          attributeName="transform"
          type="rotate"
          dur="2s"
          values="0 12 12;360 12 12"
          repeatCount="indefinite"
        />
      </g>
    </svg>
  );
};

export const SvgLoaderCircleSmall: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <g>
        <circle
          cx="12"
          cy="12"
          r="9.5"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
        >
          <animate
            attributeName="stroke-dasharray"
            dur="1.5s"
            calcMode="spline"
            values="0 150;42 150;42 150;42 150"
            keyTimes="0;0.475;0.95;1"
            keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-dashoffset"
            dur="1.5s"
            calcMode="spline"
            values="0;-16;-59;-59"
            keyTimes="0;0.475;0.95;1"
            keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1"
            repeatCount="indefinite"
          />
        </circle>
        <animateTransform
          attributeName="transform"
          type="rotate"
          dur="2s"
          values="0 12 12;360 12 12"
          repeatCount="indefinite"
        />
      </g>
    </svg>
  );
};

export const SvgFrFlag: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <rect fill="#324095" x="6" y="8" width="6" height="14"></rect>
      <rect fill="#f4f4f4" x="12" y="8" width="6" height="14"></rect>
      <rect fill="#d81e34" x="18" y="8" width="6" height="14"></rect>
    </svg>
  );
};

export const SvgItFlag: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <rect fill="#009434" x="6" y="8" width="6" height="14"></rect>
      <rect fill="#f4f4f4" x="12" y="8" width="6" height="14"></rect>
      <rect fill="#d81e34" x="18" y="8" width="6" height="14"></rect>
    </svg>
  );
};

export const SvgDeFlag: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <rect fill="currentColor" x="6" y="8" width="18" height="5"></rect>
      <rect fill="#cd2626" x="6" y="13" width="18" height="5"></rect>
      <rect fill="#ffd700" x="6" y="18" width="18" height="5"></rect>
    </svg>
  );
};
export const SvgEsFlag: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <rect fill="#AA151B" x="6" y="8" width="18" height="5"></rect>
      <rect fill="#F1BF00" x="6" y="13" width="18" height="5"></rect>
      <rect fill="#AA151B" x="6" y="18" width="18" height="5"></rect>
    </svg>
  );
};

export const SvgType_1: React.FC = () => {
  return (
    <svg viewBox="0 0 24 24">
      <path d="M17.3998 11.2894V16.8192C17.3998 16.9414 17.3535 17.0586 17.271 17.145C17.1885 17.2315 17.0765 17.28 16.9598 17.28H13.8798C13.7631 17.28 13.6512 17.2315 13.5687 17.145C13.4862 17.0586 13.4398 16.9414 13.4398 16.8192V13.8239C13.4398 13.7628 13.4167 13.7042 13.3754 13.661C13.3341 13.6177 13.2782 13.5935 13.2198 13.5935H11.0198C10.9615 13.5935 10.9055 13.6177 10.8643 13.661C10.823 13.7042 10.7998 13.7628 10.7998 13.8239V16.8192C10.7998 16.9414 10.7535 17.0586 10.671 17.145C10.5885 17.2315 10.4765 17.28 10.3598 17.28H7.27984C7.16315 17.28 7.05123 17.2315 6.96872 17.145C6.8862 17.0586 6.83984 16.9414 6.83984 16.8192V11.2894C6.83995 11.045 6.93274 10.8107 7.09779 10.6379L11.4978 6.02973C11.6628 5.85702 11.8866 5.76 12.1198 5.76C12.3531 5.76 12.5769 5.85702 12.7419 6.02973L17.1419 10.6379C17.307 10.8107 17.3997 11.045 17.3998 11.2894Z" />
      <path d="M19.5819 15.0397C19.5819 14.8148 19.5681 14.5935 19.5404 14.376C19.5128 14.1584 19.4644 13.9439 19.3953 13.7325C19.3261 13.4936 19.3331 13.2653 19.416 13.0477C19.4989 12.8301 19.6441 12.6719 19.8514 12.5729C20.0726 12.4605 20.2902 12.4501 20.5041 12.5417C20.7181 12.6334 20.8599 12.7984 20.9296 13.0368C21.0402 13.36 21.1198 13.6903 21.1685 14.0277C21.2171 14.365 21.2412 14.7023 21.2406 15.0397C21.2406 16.9231 20.5979 18.5254 19.3123 19.8466C18.0268 21.1678 16.4579 21.8284 14.6056 21.8284H14.4605L15.2069 22.5874C15.359 22.742 15.435 22.9388 15.435 23.1778C15.435 23.4167 15.359 23.6135 15.2069 23.7681C15.0549 23.9227 14.8614 24 14.6264 24C14.3914 24 14.1979 23.9227 14.0458 23.7681L11.8894 21.5754C11.7236 21.4068 11.6406 21.21 11.6406 20.9851C11.6406 20.7602 11.7236 20.5634 11.8894 20.3948L14.0458 18.2021C14.1979 18.0475 14.3914 17.9702 14.6264 17.9702C14.8614 17.9702 15.0549 18.0475 15.2069 18.2021C15.359 18.3567 15.435 18.5535 15.435 18.7925C15.435 19.0314 15.359 19.2282 15.2069 19.3828L14.4605 20.1418H14.6056C15.9879 20.1418 17.1629 19.6465 18.1305 18.6558C19.0981 17.6652 19.5819 16.4598 19.5819 15.0397Z" />
      <path d="M4.65836 8.96035C4.65836 9.18523 4.67218 9.40647 4.69983 9.62404C4.72748 9.84162 4.77586 10.0561 4.84497 10.2675C4.91409 10.5064 4.90717 10.7347 4.82424 10.9523C4.7413 11.1699 4.59616 11.3281 4.38882 11.4271C4.16765 11.5395 3.95008 11.5499 3.7361 11.4583C3.52212 11.3666 3.3803 11.2016 3.31063 10.9632C3.20005 10.64 3.12043 10.3097 3.07177 9.97234C3.02312 9.63501 2.99907 9.29768 2.99962 8.96035C2.99962 7.07692 3.64238 5.4746 4.92791 4.15339C6.21343 2.83218 7.78233 2.17157 9.63459 2.17157L9.77973 2.17157L9.0333 1.41258C8.88125 1.25797 8.80522 1.06119 8.80522 0.822248C8.80522 0.583306 8.88125 0.386528 9.0333 0.231919C9.18535 0.077309 9.37887 3.14259e-06 9.61386 3.12205e-06C9.84885 3.1015e-06 10.0424 0.0773089 10.1944 0.231919L12.3508 2.42457C12.5167 2.59323 12.5996 2.79001 12.5996 3.01489C12.5996 3.23978 12.5167 3.43656 12.3508 3.60522L10.1944 5.79787C10.0424 5.95248 9.84885 6.02979 9.61386 6.02979C9.37887 6.02979 9.18535 5.95248 9.0333 5.79787C8.88125 5.64326 8.80522 5.44649 8.80522 5.20755C8.80522 4.9686 8.88125 4.77183 9.0333 4.61722L9.77973 3.85822L9.63459 3.85822C8.25231 3.85822 7.07736 4.35354 6.10976 5.34416C5.14216 6.33479 4.65836 7.54019 4.65836 8.96035Z" />
    </svg>
  );
};

export const SvgType_2: React.FC = () => {
  return (
    <svg viewBox="0 0 24 24">
      <path d="M17.3998 11.2894V16.8192C17.3998 16.9414 17.3535 17.0586 17.271 17.145C17.1885 17.2315 17.0765 17.28 16.9598 17.28H13.8798C13.7631 17.28 13.6512 17.2315 13.5687 17.145C13.4862 17.0586 13.4398 16.9414 13.4398 16.8192V13.8239C13.4398 13.7628 13.4167 13.7042 13.3754 13.661C13.3341 13.6177 13.2782 13.5935 13.2198 13.5935H11.0198C10.9615 13.5935 10.9055 13.6177 10.8643 13.661C10.823 13.7042 10.7998 13.7628 10.7998 13.8239V16.8192C10.7998 16.9414 10.7535 17.0586 10.671 17.145C10.5885 17.2315 10.4765 17.28 10.3598 17.28H7.27984C7.16315 17.28 7.05123 17.2315 6.96872 17.145C6.8862 17.0586 6.83984 16.9414 6.83984 16.8192V11.2894C6.83995 11.045 6.93274 10.8107 7.09779 10.6379L11.4978 6.02973C11.6628 5.85702 11.8866 5.76 12.1198 5.76C12.3531 5.76 12.5769 5.85702 12.7419 6.02973L17.1419 10.6379C17.307 10.8107 17.3997 11.045 17.3998 11.2894Z" />
      <path d="M21.2405 3.84619C21.2388 3.9716 21.1983 4.09338 21.1245 4.19468C21.0508 4.29598 20.9474 4.37179 20.8288 4.41163L19.7684 4.76221C19.4343 4.87767 19.1326 5.07154 18.8885 5.32765C18.6344 5.57578 18.4413 5.87968 18.3244 6.21539L17.9578 7.27277C17.916 7.3894 17.8416 7.49148 17.7434 7.5668C17.6393 7.64013 17.5153 7.6796 17.3881 7.67989C17.2622 7.68238 17.1391 7.64257 17.0384 7.5668C16.9355 7.49255 16.8585 7.3877 16.8184 7.26712L16.463 6.20409C16.353 5.8699 16.1667 5.56606 15.919 5.31673C15.6713 5.0674 15.3689 4.87946 15.036 4.76786L13.9756 4.41729C13.8563 4.37514 13.7522 4.29838 13.6766 4.19677C13.6202 4.11978 13.5829 4.0304 13.568 3.93606C13.553 3.84172 13.5607 3.74515 13.5905 3.65442C13.6203 3.56368 13.6713 3.4814 13.7393 3.41444C13.8073 3.34747 13.8902 3.29776 13.9812 3.26944L15.036 2.91887C15.3727 2.80896 15.6788 2.62118 15.9296 2.37069C16.1805 2.1202 16.369 1.81405 16.48 1.47699L16.8297 0.425265C16.8638 0.307814 16.9351 0.204642 17.0327 0.131235C17.1297 0.0505726 17.2508 0.00478812 17.3768 0.00118346C17.5052 -0.00715489 17.6326 0.0287573 17.7378 0.102963C17.846 0.1718 17.9275 0.275499 17.9691 0.396993L18.3244 1.47133C18.434 1.80883 18.6214 2.11572 18.8712 2.36719C19.1211 2.61866 19.4265 2.80764 19.7627 2.91887L20.8175 3.2864C20.9362 3.32364 21.0394 3.39918 21.1108 3.50127C21.1878 3.60046 21.2331 3.72072 21.2405 3.84619Z" />
      <path d="M8.76 21.1246C8.75872 21.2187 8.72832 21.31 8.67299 21.386C8.61767 21.462 8.54016 21.5188 8.45118 21.5487L7.65587 21.8117C7.40531 21.8982 7.17904 22.0437 6.99593 22.2357C6.80538 22.4218 6.66057 22.6498 6.57289 22.9015L6.29792 23.6946C6.26659 23.782 6.21078 23.8586 6.13716 23.9151C6.0591 23.9701 5.96606 23.9997 5.87065 23.9999C5.77623 24.0018 5.6839 23.9719 5.60837 23.9151C5.53119 23.8594 5.47346 23.7808 5.44338 23.6903L5.17687 22.8931C5.09436 22.6424 4.95465 22.4145 4.76884 22.2275C4.58304 22.0405 4.35627 21.8996 4.10658 21.8159L3.31127 21.553C3.22182 21.5214 3.14377 21.4638 3.08706 21.3876C3.04474 21.3298 3.0168 21.2628 3.00557 21.192C2.99434 21.1213 3.00014 21.0489 3.02249 20.9808C3.04485 20.9128 3.0831 20.8511 3.13407 20.8008C3.18504 20.7506 3.24724 20.7133 3.3155 20.6921L4.10658 20.4291C4.35908 20.3467 4.58868 20.2059 4.77682 20.018C4.96496 19.8302 5.10635 19.6005 5.18956 19.3477L5.45184 18.5589C5.47747 18.4709 5.53091 18.3935 5.60414 18.3384C5.67687 18.2779 5.76772 18.2436 5.86219 18.2409C5.95848 18.2346 6.05401 18.2616 6.13293 18.3172C6.21405 18.3688 6.27522 18.4466 6.30638 18.5377L6.57289 19.3435C6.65512 19.5966 6.79561 19.8268 6.98301 20.0154C7.17042 20.204 7.39947 20.3457 7.65164 20.4291L8.44272 20.7048C8.53177 20.7327 8.60911 20.7894 8.6627 20.866C8.72046 20.9403 8.75439 21.0305 8.76 21.1246Z" />
    </svg>
  );
};

export const SvgType_3: React.FC = () => {
  return (
    <svg viewBox="0 0 24 24">
      <path d="M12.0002 12C12.0002 12.7879 11.845 13.5681 11.5435 14.2961C11.242 15.0241 10.8 15.6855 10.2428 16.2426C9.68568 16.7998 9.02423 17.2417 8.29627 17.5433C7.5683 17.8448 6.78807 18 6.00012 18C5.21217 18 4.43194 17.8448 3.70397 17.5433C2.976 17.2417 2.31456 16.7998 1.75739 16.2426C1.20023 15.6855 0.758266 15.0241 0.456732 14.2961C0.155198 13.5681 -6.88845e-08 12.7879 0 12L6.00012 12H12.0002Z" />
      <path d="M11.9998 12C11.9998 11.2121 12.155 10.4319 12.4565 9.7039C12.758 8.97595 13.2 8.31451 13.7572 7.75736C14.3143 7.20021 14.9758 6.75825 15.7037 6.45672C16.4317 6.1552 17.2119 6 17.9999 6C18.7878 6 19.5681 6.1552 20.296 6.45672C21.024 6.75825 21.6854 7.20021 22.2426 7.75736C22.7998 8.31451 23.2417 8.97595 23.5433 9.7039C23.8448 10.4319 24 11.2121 24 12L17.9999 12L11.9998 12Z" />
      <path d="M11.9999 12C11.2119 12 10.4317 11.8448 9.70373 11.5433C8.97577 11.2417 8.31432 10.7998 7.75715 10.2426C7.19999 9.68549 6.75803 9.02405 6.45649 8.2961C6.15496 7.56815 5.99976 6.78793 5.99976 6C5.99976 5.21207 6.15496 4.43185 6.45649 3.7039C6.75803 2.97594 7.19999 2.31451 7.75716 1.75736C8.31432 1.20021 8.97577 0.75825 9.70374 0.456722C10.4317 0.155194 11.2119 -3.65593e-07 11.9999 -2.62268e-07L11.9999 6L11.9999 12Z" />
      <path d="M12.0001 12C12.7881 12 13.5683 12.1552 14.2963 12.4568C15.0242 12.7583 15.6857 13.2002 16.2428 13.7574C16.8 14.3145 17.242 14.976 17.5435 15.7039C17.845 16.4319 18.0002 17.2121 18.0002 18C18.0002 18.788 17.845 19.5682 17.5435 20.2961C17.242 21.0241 16.8 21.6855 16.2428 22.2427C15.6857 22.7998 15.0242 23.2418 14.2963 23.5433C13.5683 23.8448 12.7881 24 12.0001 24L12.0001 18L12.0001 12Z" />
    </svg>
  );
};

export const SvgType_4: React.FC = () => {
  return (
    <svg viewBox="0 0 45 24">
      <path d="M12.0022 12C12.0022 12.7879 11.847 13.5681 11.5455 14.2961C11.2439 15.0241 10.802 15.6855 10.2448 16.2426C9.68763 16.7998 9.02619 17.2417 8.29822 17.5433C7.57025 17.8448 6.79002 18 6.00207 18C5.21413 18 4.43389 17.8448 3.70593 17.5433C2.97796 17.2417 2.31651 16.7998 1.75935 16.2426C1.20218 15.6855 0.760219 15.0241 0.458685 14.2961C0.157151 13.5681 0.00195306 12.7879 0.00195313 12L6.00207 12H12.0022Z" />
      <path d="M12.0017 12C12.0017 11.2121 12.1569 10.4319 12.4584 9.7039C12.76 8.97595 13.2019 8.31451 13.7591 7.75736C14.3163 7.20021 14.9777 6.75825 15.7057 6.45672C16.4337 6.1552 17.2139 6 18.0018 6C18.7898 6 19.57 6.1552 20.298 6.45672C21.0259 6.75825 21.6874 7.20021 22.2446 7.75736C22.8017 8.31451 23.2437 8.97595 23.5452 9.7039C23.8468 10.4319 24.002 11.2121 24.002 12L18.0018 12L12.0017 12Z" />
      <path d="M12.0018 12C11.2139 12 10.4337 11.8448 9.70569 11.5433C8.97772 11.2417 8.31627 10.7998 7.75911 10.2426C7.20195 9.68549 6.75998 9.02405 6.45845 8.2961C6.15691 7.56815 6.00171 6.78793 6.00171 6C6.00171 5.21207 6.15691 4.43185 6.45845 3.7039C6.75998 2.97594 7.20195 2.31451 7.75911 1.75736C8.31627 1.20021 8.97772 0.75825 9.70569 0.456722C10.4337 0.155194 11.2139 -3.65593e-07 12.0018 -2.62268e-07L12.0018 6L12.0018 12Z" />
      <path d="M12.0021 12C12.79 12 13.5703 12.1552 14.2982 12.4567C15.0262 12.7583 15.6876 13.2002 16.2448 13.7574C16.802 14.3145 17.2439 14.9759 17.5455 15.7039C17.847 16.4319 18.0022 17.2121 18.0022 18C18.0022 18.7879 17.847 19.5681 17.5455 20.2961C17.2439 21.0241 16.802 21.6855 16.2448 22.2426C15.6876 22.7998 15.0262 23.2418 14.2982 23.5433C13.5703 23.8448 12.79 24 12.0021 24L12.0021 18L12.0021 12Z" />
      <path d="M33.0015 23C31.4986 22.9999 30.0304 22.5483 28.7873 21.7037C27.5442 20.8592 26.5834 19.6606 26.0297 18.2635C25.4759 16.8664 25.3546 15.3352 25.6816 13.8683C26.0086 12.4015 26.7687 11.0667 27.8634 10.037C29.2054 8.774 32.5015 6.5 32.0014 1.5C38.0016 5.5 41.0016 9.5 35.0015 15.5C36.0015 15.5 37.5016 15.5 40.0016 13.03C40.2716 13.803 40.5016 14.634 40.5016 15.5C40.5016 17.4891 39.7114 19.3968 38.3049 20.8033C36.8983 22.2098 34.9906 23 33.0015 23Z" />
    </svg>
  );
};

export const SvgDrop: React.FC = () => {
  return (
    <svg viewBox="0 0 24 24">
      <path d="M9.78237 2.64601C10.3366 1.83097 10.8256 1.08113 11.282 0.396503C11.3472 0.298698 11.445 0.200894 11.5429 0.135691C11.9341 -0.125121 12.4557 0.00528451 12.7165 0.396503C13.1403 1.08113 13.6293 1.79837 14.2162 2.64601C16.7917 6.42778 20.6387 12.133 20.6387 15.3932C20.6387 17.7731 19.6606 19.9248 18.0958 21.4897C16.5309 23.0219 14.3792 24 11.9993 24C9.61937 24 7.46767 23.0219 5.9028 21.4571C4.33792 19.8922 3.35988 17.7405 3.35988 15.3606C3.35988 12.1004 7.20685 6.42778 9.78237 2.64601ZM7.07645 20.2834C8.34791 21.5549 10.0758 22.3047 11.9993 22.3047C13.9228 22.3047 15.6506 21.5223 16.9221 20.2834C18.1936 19.012 18.9434 17.2841 18.9434 15.3606C18.9434 12.6221 15.2594 7.17761 12.8143 3.55885C12.5209 3.13503 12.2601 2.71121 11.9993 2.35259C11.7385 2.71121 11.4777 3.13503 11.1842 3.55885C8.73912 7.21022 5.05515 12.6221 5.05516 15.3606C5.05516 17.2841 5.83759 19.012 7.07645 20.2834Z" />
      <path d="M6.94729 14.7735C7.40371 14.7409 7.79493 15.0996 7.82753 15.556C7.86013 16.2732 8.08835 16.9578 8.44696 17.5447C8.80558 18.1315 9.3272 18.6531 9.94663 18.9791C10.3378 19.2073 10.5009 19.729 10.2726 20.1202C10.0118 20.5766 9.49021 20.707 9.09899 20.4788C8.21875 19.9898 7.50152 19.2726 7.0125 18.4575C6.49087 17.6425 6.19746 16.6644 6.16486 15.6538C6.13226 15.1974 6.49087 14.8061 6.94729 14.7735Z" />
    </svg>
  );
};

export const SvgHot: React.FC = () => {
  return (
    <svg viewBox="0 0 24 24">
      <path d="M10.1741 2.66569C14.3675 7.37769 13.2483 8.95769 11.0188 12.1057C10.7171 12.5314 10.4036 12.9748 10.0888 13.4457C7.61751 17.1491 9.96321 21.1237 11.5481 22.7077C11.7363 22.8914 11.9893 22.9936 12.2523 22.9922C12.5154 22.9907 12.7672 22.8856 12.9533 22.6998C13.1394 22.5139 13.2448 22.2622 13.2467 21.9992C13.2485 21.7362 13.1467 21.483 12.9632 21.2946C12.8137 21.1433 9.58231 17.8083 11.7532 14.5554C12.0559 14.1013 12.3596 13.6736 12.6507 13.2624C14.9407 10.029 16.9182 7.23609 11.6682 1.33569C11.5809 1.23759 11.4751 1.15764 11.3569 1.10043C11.2386 1.04321 11.1103 1.00984 10.9792 1.00222C10.8481 0.9946 10.7167 1.01288 10.5927 1.05602C10.4686 1.09916 10.3543 1.16631 10.2562 1.25364C10.1581 1.34097 10.0781 1.44677 10.0209 1.56499C9.96368 1.68322 9.93031 1.81155 9.92269 1.94267C9.91507 2.07379 9.93335 2.20513 9.97649 2.32919C10.0196 2.45324 10.0868 2.56759 10.1741 2.66569ZM17.9124 12.7439C17.4446 13.6052 16.9602 14.4958 16.5803 15.3913C16.1419 16.4236 16.3203 17.3972 17.262 19.112C17.3298 19.2273 17.3737 19.355 17.3913 19.4876C17.4088 19.6202 17.3995 19.755 17.3641 19.8839C17.3286 20.0129 17.2676 20.1334 17.1847 20.2384C17.1018 20.3434 16.9987 20.4306 16.8815 20.4951C16.7643 20.5595 16.6354 20.5997 16.5023 20.6134C16.3693 20.6271 16.2349 20.614 16.107 20.5748C15.9791 20.5357 15.8604 20.4712 15.7578 20.3853C15.6553 20.2995 15.571 20.1939 15.51 20.0749C14.6038 18.4275 13.8841 16.6249 14.7385 14.6101C15.1575 13.6247 15.6643 12.6911 16.1555 11.7888C17.9837 8.42749 19.304 5.99879 15.8928 2.72139C15.7017 2.53749 15.5914 2.28519 15.5863 2.01999C15.5812 1.7548 15.6816 1.49843 15.8655 1.30729C16.0494 1.11615 16.3017 1.00589 16.5669 1.00077C16.8321 0.995651 17.0885 1.09609 17.2796 1.27999C21.7893 5.61399 19.7298 9.40209 17.9124 12.7439ZM4.38601 13.3139C4.86937 12.2366 5.43142 11.1963 6.06761 10.2016C7.79621 7.36559 8.74831 5.80309 5.54031 2.72159C5.44566 2.63054 5.36988 2.52174 5.31728 2.4014C5.26469 2.28106 5.23631 2.15154 5.23377 2.02023C5.22864 1.75504 5.32907 1.49868 5.51296 1.30754C5.69684 1.1164 5.94913 1.00613 6.21432 1.00101C6.4795 0.995876 6.73587 1.0963 6.92701 1.28019C11.2913 5.47449 9.50421 8.40709 7.77571 11.2431C7.19034 12.1545 6.67297 13.1079 6.22781 14.0954C5.78931 15.1267 5.96781 16.1003 6.91041 17.8154C6.97362 17.9306 7.01354 18.057 7.02788 18.1876C7.04221 18.3182 7.03069 18.4504 6.99396 18.5765C6.95723 18.7026 6.89601 18.8203 6.81381 18.9228C6.7316 19.0252 6.63002 19.1105 6.51486 19.1737C6.39969 19.237 6.27321 19.2769 6.14262 19.2912C6.01203 19.3055 5.8799 19.294 5.75376 19.2573C5.62763 19.2206 5.50996 19.1593 5.40748 19.0771C5.30501 18.9949 5.21973 18.8934 5.15651 18.7782C4.25221 17.1296 3.53151 15.3275 4.38601 13.3139Z" />
    </svg>
  );
};

export const SvgTriple_mix: React.FC = () => {
  return (
    <svg viewBox="0 0 24 24">
      <path d="M20.0673 22.3982C17.9042 19.9877 18.4815 19.1795 19.6315 17.5691C19.7872 17.3513 19.9489 17.1245 20.1113 16.8836C21.386 14.9891 20.176 12.9558 19.3585 12.1455C19.2614 12.0515 19.1309 11.9993 18.9953 12C18.8596 12.0008 18.7297 12.0545 18.6337 12.1496C18.5377 12.2447 18.4833 12.3734 18.4823 12.508C18.4814 12.6425 18.5339 12.772 18.6286 12.8684C18.7057 12.9458 20.3725 14.6519 19.2527 16.3159C19.0966 16.5482 18.9399 16.767 18.7898 16.9774C17.6085 18.6314 16.5885 20.0602 19.2966 23.0785C19.3416 23.1287 19.3962 23.1696 19.4572 23.1989C19.5181 23.2282 19.5843 23.2452 19.652 23.2491C19.7196 23.253 19.7874 23.2437 19.8514 23.2216C19.9153 23.1995 19.9743 23.1652 20.0249 23.1205C20.0755 23.0758 20.1168 23.0217 20.1463 22.9612C20.1758 22.9008 20.193 22.8351 20.1969 22.768C20.2009 22.701 20.1914 22.6338 20.1692 22.5703C20.1469 22.5069 20.1123 22.4484 20.0673 22.3982ZM16.0756 17.2426C16.317 16.802 16.5668 16.3464 16.7628 15.8883C16.9889 15.3602 16.8969 14.8622 16.4111 13.9849C16.3762 13.926 16.3535 13.8606 16.3445 13.7928C16.3354 13.725 16.3402 13.656 16.3585 13.5901C16.3768 13.5241 16.4083 13.4624 16.451 13.4087C16.4938 13.355 16.5469 13.3104 16.6074 13.2774C16.6679 13.2445 16.7344 13.2239 16.803 13.2169C16.8716 13.2099 16.941 13.2166 17.0069 13.2366C17.0729 13.2567 17.1341 13.2896 17.187 13.3335C17.2399 13.3775 17.2834 13.4315 17.3149 13.4924C17.7823 14.3351 18.1535 15.2572 17.7128 16.2879C17.4967 16.792 17.2353 17.2696 16.9819 17.7312C16.0389 19.4507 15.3578 20.6931 17.1174 22.3697C17.216 22.4638 17.2729 22.5928 17.2755 22.7285C17.2782 22.8641 17.2264 22.9953 17.1315 23.0931C17.0366 23.1909 16.9065 23.2473 16.7697 23.2499C16.6329 23.2525 16.5007 23.2011 16.4021 23.107C14.0758 20.89 15.1382 18.9521 16.0756 17.2426ZM23.0529 16.951C22.8036 17.5021 22.5137 18.0343 22.1855 18.5431C21.2938 19.9939 20.8027 20.7932 22.4575 22.3696C22.5063 22.4162 22.5454 22.4718 22.5725 22.5334C22.5997 22.5949 22.6143 22.6612 22.6156 22.7284C22.6183 22.864 22.5664 22.9952 22.4716 23.0929C22.3767 23.1907 22.2466 23.2471 22.1098 23.2498C21.973 23.2524 21.8408 23.201 21.7422 23.1069C19.491 20.9613 20.4128 19.4611 21.3044 18.0103C21.6064 17.5441 21.8732 17.0564 22.1029 16.5512C22.329 16.0237 22.237 15.5256 21.7508 14.6482C21.7181 14.5893 21.6976 14.5246 21.6902 14.4578C21.6828 14.391 21.6887 14.3234 21.7077 14.2589C21.7266 14.1944 21.7582 14.1342 21.8006 14.0817C21.843 14.0293 21.8954 13.9857 21.9548 13.9534C22.0142 13.921 22.0794 13.9006 22.1468 13.8933C22.2142 13.8859 22.2823 13.8918 22.3474 13.9106C22.4124 13.9294 22.4731 13.9607 22.526 14.0028C22.5789 14.0448 22.6229 14.0968 22.6555 14.1557C23.1219 14.9991 23.4937 15.9209 23.0529 16.951Z" />
      <path d="M4.08206 13.2161C4.36194 12.8045 4.6089 12.4259 4.83939 12.0801C4.87232 12.0307 4.92171 11.9813 4.9711 11.9484C5.16866 11.8167 5.43208 11.8826 5.56379 12.0801C5.77782 12.4259 6.02477 12.7881 6.32112 13.2161C7.62174 15.1259 9.56445 18.007 9.56445 19.6534C9.56445 20.8552 9.07055 21.9418 8.28029 22.7321C7.49004 23.5059 6.40344 23.9998 5.20159 23.9998C3.99975 23.9998 2.91315 23.5059 2.12289 22.7156C1.33264 21.9254 0.838729 20.8388 0.838729 19.6369C0.838728 17.9906 2.78144 15.1259 4.08206 13.2161ZM2.71558 22.1229C3.35766 22.765 4.23024 23.1437 5.20159 23.1437C6.17295 23.1437 7.04552 22.7485 7.6876 22.1229C8.32968 21.4808 8.70834 20.6083 8.70834 19.6369C8.70834 18.254 6.84795 15.5046 5.61318 13.6771C5.46501 13.4631 5.3333 13.249 5.20159 13.0679C5.06988 13.249 4.93817 13.4631 4.79 13.6771C3.55523 15.521 1.69484 18.254 1.69484 19.6369C1.69484 20.6083 2.08996 21.4808 2.71558 22.1229Z" />
      <path
        d="M2.84359 18.7365C3.10223 18.7186 3.32393 18.9149 3.3424 19.1647C3.36088 19.5573 3.4902 19.9321 3.69342 20.2533C3.89664 20.5745 4.19224 20.86 4.54325 21.0384C4.76495 21.1633 4.85732 21.4488 4.728 21.663C4.5802 21.9128 4.28461 21.9842 4.06291 21.8593C3.5641 21.5916 3.15766 21.199 2.88054 20.7529C2.58494 20.3068 2.41867 19.7715 2.4002 19.2183C2.38172 18.9685 2.58494 18.7543 2.84359 18.7365Z"
        fill="#2F2F2F"
      />
      <path d="M11.9313 0.137696C12.152 0.137696 12.3728 0.286148 12.3686 0.581847L12.3686 1.95018L13.1723 1.14558C13.3442 0.968775 13.6287 0.968718 13.7984 1.14383C13.968 1.31903 13.9636 1.59572 13.7907 1.76394C13.3167 2.23799 12.8426 2.71202 12.3686 3.18608L12.3686 5.50337L14.3758 4.34515C14.5493 3.69744 14.7224 3.0497 14.8959 2.40198C14.9552 2.16815 15.1924 2.02665 15.4289 2.08595C15.6654 2.14538 15.8078 2.39109 15.7406 2.62833L15.446 3.72676L16.6315 3.04259C16.8387 2.91913 17.1066 2.98626 17.2319 3.19548C17.3572 3.40477 17.2841 3.67912 17.0688 3.79936L15.8841 4.48353L16.9817 4.77735C17.2207 4.83778 17.3628 5.08433 17.296 5.31888C17.2291 5.55338 16.9874 5.68771 16.7553 5.62209C16.108 5.44863 15.4604 5.27539 14.8131 5.10192L12.8059 6.26099L14.8131 7.41921C15.4604 7.24574 16.108 7.07251 16.7553 6.89904C16.9874 6.83342 17.2291 6.96775 17.296 7.20226C17.3628 7.4368 17.2207 7.68335 16.9817 7.74378L15.8833 8.03761L17.0688 8.72178C17.2841 8.84202 17.3572 9.11637 17.2319 9.32565C17.1066 9.53488 16.8387 9.602 16.6315 9.47854L15.446 8.79438L15.7406 9.8928C15.8078 10.13 15.6654 10.3758 15.4289 10.4352C15.1924 10.4945 14.9552 10.353 14.8959 10.1191C14.7224 9.47144 14.5493 8.82369 14.3758 8.17598L12.3686 7.01776L12.3686 9.33505C12.8426 9.80911 13.3167 10.2831 13.7907 10.7572C13.9636 10.9254 13.968 11.2021 13.7984 11.3773C13.6287 11.5525 13.3442 11.5524 13.1723 11.3755L12.3686 10.5718L12.3686 11.9393C12.3721 12.1858 12.1717 12.3864 11.9279 12.3826C11.684 12.3786 11.4907 12.1805 11.494 11.9393L11.494 10.5735L10.6911 11.3755C10.5193 11.5524 10.2348 11.5524 10.065 11.3773C9.89543 11.2021 9.89984 10.9254 10.0727 10.7572C10.5465 10.2834 11.0202 9.80968 11.494 9.3359L11.494 7.01862L9.48768 8.17683C9.31419 8.82429 9.14013 9.4717 8.96667 10.1191C8.90743 10.353 8.67023 10.4945 8.4337 10.4352C8.19718 10.3757 8.05476 10.13 8.12194 9.8928L8.41576 8.79523L7.23196 9.47854C6.72399 9.7815 6.27832 9.00939 6.79465 8.72092L7.97845 8.03761L6.88177 7.74378C6.64272 7.68335 6.50066 7.4368 6.56745 7.20226C6.63436 6.96775 6.87599 6.83343 7.10811 6.89904C7.7552 7.07244 8.40241 7.24581 9.04952 7.41921L11.0567 6.26099L9.04952 5.10192C8.40241 5.27532 7.7552 5.4487 7.10811 5.62209C6.87599 5.68771 6.63436 5.55338 6.56745 5.31888C6.50066 5.08434 6.64272 4.83778 6.88176 4.77735L7.97845 4.48353L6.79465 3.80021C6.27832 3.51175 6.72399 2.73964 7.23196 3.04259L8.41661 3.72676L8.12194 2.62833C8.05476 2.39109 8.19719 2.14538 8.4337 2.08595C8.67023 2.02665 8.90743 2.16816 8.96667 2.40198C9.14021 3.0497 9.31412 3.69743 9.48768 4.34515L11.494 5.50337L11.494 3.18523C11.0202 2.71145 10.5465 2.2377 10.0727 1.76394C9.89985 1.59572 9.89543 1.31903 10.065 1.14383C10.2348 0.968679 10.5193 0.968736 10.6911 1.14558L11.494 1.94847L11.494 0.581847C11.4896 0.286149 11.7105 0.137696 11.9313 0.137696Z" />
    </svg>
  );
};

export const SvgDouble_mix: React.FC = () => {
  return (
    <svg viewBox="0 0 24 24">
      <path d="M19.6599 17.671C16.7103 14.6178 17.4975 13.594 19.0657 11.5542C19.278 11.2783 19.4985 10.991 19.7199 10.6859C21.4582 8.28617 19.8082 5.71074 18.6934 4.68435C18.5611 4.56528 18.3831 4.49905 18.1981 4.50001C18.0131 4.50097 17.8359 4.56903 17.705 4.68946C17.5741 4.80989 17.4999 4.97299 17.4986 5.14342C17.4973 5.31384 17.569 5.47788 17.698 5.6C17.8032 5.69804 20.0762 7.85903 18.5492 9.96682C18.3362 10.2611 18.1226 10.5382 17.9179 10.8046C16.3071 12.8998 14.9161 14.7095 18.6089 18.5328C18.6704 18.5964 18.7448 18.6482 18.828 18.6853C18.9111 18.7223 19.0014 18.744 19.0936 18.7489C19.1858 18.7538 19.2782 18.742 19.3655 18.714C19.4527 18.6861 19.5332 18.6426 19.6022 18.586C19.6712 18.5294 19.7274 18.4609 19.7677 18.3842C19.8079 18.3076 19.8314 18.2245 19.8367 18.1395C19.8421 18.0546 19.8292 17.9695 19.7989 17.8891C19.7686 17.8087 19.7213 17.7346 19.6599 17.671ZM14.2168 11.1406C14.5458 10.5825 14.8866 10.0054 15.1538 9.42518C15.4622 8.75627 15.3367 8.12541 14.6743 7.01426C14.6266 6.93955 14.5957 6.85678 14.5834 6.77087C14.571 6.68495 14.5775 6.59763 14.6025 6.51407C14.6275 6.43051 14.6703 6.35241 14.7286 6.28439C14.7869 6.21637 14.8595 6.15982 14.9419 6.11808C15.0244 6.07634 15.1151 6.05025 15.2086 6.04138C15.3022 6.0325 15.3968 6.041 15.4867 6.06639C15.5767 6.09177 15.6602 6.13352 15.7323 6.18916C15.8044 6.2448 15.8637 6.31321 15.9066 6.39033C16.5441 7.4578 17.0503 8.62584 16.4493 9.93137C16.1546 10.5699 15.7981 11.1748 15.4526 11.7595C14.1666 13.9375 13.2379 15.5113 15.6374 17.6349C15.7718 17.7541 15.8494 17.9176 15.853 18.0894C15.8566 18.2613 15.7859 18.4274 15.6566 18.5512C15.5272 18.6751 15.3498 18.7465 15.1632 18.7498C14.9767 18.7532 14.7964 18.6881 14.6619 18.5689C11.4898 15.7606 12.9384 13.306 14.2168 11.1406ZM23.7312 10.7713C23.3912 11.4693 22.9959 12.1434 22.5484 12.788C21.3325 14.6256 20.6628 15.6381 22.9193 17.6348C22.9859 17.6938 23.0392 17.7643 23.0762 17.8423C23.1132 17.9203 23.1331 18.0042 23.1349 18.0893C23.1385 18.2611 23.0679 18.4272 22.9385 18.5511C22.8092 18.6749 22.6317 18.7464 22.4452 18.7497C22.2587 18.753 22.0783 18.6879 21.9439 18.5688C18.8741 15.851 20.1311 13.9507 21.3469 12.1131C21.7587 11.5225 22.1226 10.9048 22.4357 10.2649C22.7442 9.59663 22.6186 8.96576 21.9556 7.85442C21.9111 7.7798 21.883 7.69784 21.8729 7.61322C21.8629 7.52861 21.871 7.44299 21.8968 7.36126C21.9226 7.27952 21.9657 7.20328 22.0235 7.13688C22.0813 7.07048 22.1528 7.01521 22.2338 6.97425C22.3148 6.93329 22.4038 6.90742 22.4956 6.89813C22.5875 6.88884 22.6804 6.89631 22.7692 6.92011C22.8579 6.94391 22.9406 6.98358 23.0127 7.03685C23.0848 7.09011 23.1448 7.15593 23.1893 7.23056C23.8253 8.2988 24.3323 9.46652 23.7312 10.7713Z" />
      <path d="M4.08635 5.58891C4.439 5.07031 4.75016 4.59319 5.04058 4.15757C5.08207 4.09533 5.1443 4.0331 5.20653 3.99161C5.45546 3.82566 5.78737 3.90864 5.95332 4.15757C6.22299 4.59319 6.53416 5.04956 6.90755 5.58891C8.54634 7.99523 10.9941 11.6254 10.9941 13.6999C10.9941 15.2142 10.3718 16.5833 9.3761 17.579C8.38038 18.554 7.01127 19.1763 5.49695 19.1763C3.98263 19.1763 2.61352 18.554 1.6178 17.5583C0.622086 16.5625 -0.000237432 15.1934 -0.000237564 13.6791C-0.000237745 11.6047 2.44757 7.99523 4.08635 5.58891ZM2.36459 16.8115C3.17361 17.6205 4.27305 18.0976 5.49695 18.0976C6.72085 18.0976 7.82029 17.5997 8.62931 16.8115C9.43833 16.0025 9.91545 14.903 9.91545 13.6791C9.91545 11.9366 7.57136 8.47234 6.01555 6.16974C5.82886 5.90007 5.6629 5.6304 5.49695 5.40221C5.331 5.6304 5.16505 5.90007 4.97835 6.16974C3.42254 8.49309 1.07845 11.9366 1.07845 13.6791C1.07845 14.903 1.57631 16.0025 2.36459 16.8115Z" />
      <path
        d="M2.52774 12.5454C2.85363 12.5229 3.13296 12.7702 3.15624 13.085C3.17952 13.5796 3.34246 14.0518 3.59852 14.4565C3.85458 14.8612 4.22703 15.2209 4.66931 15.4458C4.94864 15.6032 5.06503 15.9629 4.90209 16.2327C4.71586 16.5475 4.34342 16.6374 4.06408 16.48C3.43558 16.1428 2.92346 15.6481 2.57429 15.086C2.20184 14.5239 1.99234 13.8494 1.96906 13.1524C1.94579 12.8377 2.20184 12.5678 2.52774 12.5454Z"
        fill="#2F2F2F"
      />
    </svg>
  );
};

export const SvgGift: React.FC = () => {
  return (
    <svg viewBox="-1 -1 24 24">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.5 2C6.10218 2 5.72064 2.15804 5.43934 2.43934C5.15804 2.72064 5 3.10218 5 3.5C5 3.89782 5.15804 4.27936 5.43934 4.56066C5.72064 4.84196 6.10218 5 6.5 5H9.65402C9.53195 4.68061 9.37741 4.32942 9.18628 3.98192C8.55732 2.83834 7.6939 2 6.5 2ZM10 7V10H2V7H10ZM3.33772 5C3.11743 4.53557 3 4.02384 3 3.5C3 2.57174 3.36875 1.6815 4.02513 1.02513C4.6815 0.368749 5.57174 0 6.5 0C8.8061 0 10.1927 1.66166 10.9387 3.01808C10.9595 3.0559 10.9799 3.09368 11 3.13141C11.0201 3.09368 11.0405 3.0559 11.0613 3.01808C11.8073 1.66166 13.1939 0 15.5 0C16.4283 0 17.3185 0.368749 17.9749 1.02513C18.6313 1.6815 19 2.57174 19 3.5C19 4.02384 18.8826 4.53557 18.6623 5H21C21.5523 5 22 5.44772 22 6V11C22 11.5523 21.5523 12 21 12H20V21C20 21.5523 19.5523 22 19 22H3C2.44772 22 2 21.5523 2 21V12H1C0.447715 12 0 11.5523 0 11V6C0 5.44772 0.447715 5 1 5H3.33772ZM4 12V20H10V12H4ZM12 12V20H18V12H12ZM20 10H12V7H20V10ZM15.5 5C15.8978 5 16.2794 4.84196 16.5607 4.56066C16.842 4.27936 17 3.89782 17 3.5C17 3.10218 16.842 2.72064 16.5607 2.43934C16.2794 2.15804 15.8978 2 15.5 2C14.3061 2 13.4427 2.83834 12.8137 3.98192C12.6226 4.32942 12.4681 4.68061 12.346 5H15.5Z"
      />
    </svg>
  );
};

export const SvgHelp: React.FC = () => {
  return (
    <svg viewBox="0 0 24 25">
      <path d="M12.0002 24.0176C10.4545 24.0176 9.00113 23.7258 7.64187 23.1412C6.27152 22.5581 5.07792 21.759 4.06279 20.7438C3.04766 19.7287 2.24857 18.5351 1.66539 17.1648C1.08081 15.8055 0.789062 14.3521 0.789062 12.8064C0.789062 11.2607 1.08086 9.80717 1.66553 8.44781C2.24879 7.09172 3.0479 5.90547 4.06279 4.89058C5.07766 3.87571 6.27086 3.06964 7.6407 2.47215L7.64156 2.47178C9.00091 1.88711 10.4544 1.59531 12.0002 1.59531C13.546 1.59531 14.9995 1.88711 16.3588 2.47178L16.3597 2.47215C17.7295 3.06964 18.9227 3.87571 19.9376 4.89058C20.9525 5.90547 21.7516 7.09172 22.3349 8.44781C22.9195 9.80717 23.2113 11.2607 23.2113 12.8064C23.2113 14.3522 22.9195 15.8057 22.3349 17.165C21.7517 18.5352 20.9527 19.7288 19.9376 20.7438C18.9224 21.759 17.7288 22.5581 16.3584 23.1413C14.9991 23.7258 13.5458 24.0176 12.0002 24.0176ZM8.32552 21.5328C9.46431 22.0249 10.6885 22.2716 12.0002 22.2716C13.3118 22.2716 14.5368 22.0246 15.6756 21.5325C16.832 21.0389 17.8351 20.3629 18.6864 19.5045C19.5384 18.6455 20.2186 17.6381 20.7268 16.4807C21.2187 15.342 21.4653 14.1179 21.4653 12.8064C21.4653 11.5098 21.2189 10.2855 20.7266 9.13185C20.2185 7.97475 19.5385 6.97127 18.6869 6.1197C17.8353 5.26804 16.8317 4.58801 15.6745 4.07988C14.5358 3.58793 13.3117 3.34131 12.0002 3.34131C10.6887 3.34131 9.46461 3.58792 8.32594 4.07988C7.1687 4.58801 6.1651 5.26804 5.31345 6.1197C4.46187 6.97128 3.78189 7.97476 3.27377 9.13187C2.78151 10.2855 2.53506 11.5098 2.53506 12.8064C2.53506 14.1179 2.78166 15.342 3.2736 16.4806C3.78179 17.638 4.46198 18.6455 5.31398 19.5045C6.16533 20.3629 7.16911 21.0392 8.32552 21.5328ZM11.311 18.8485C10.9756 18.8485 10.6846 18.729 10.4487 18.4932C10.2129 18.2573 10.0934 17.9663 10.0934 17.6309C10.0934 17.2956 10.2129 17.0045 10.4487 16.7687C10.6846 16.5328 10.9756 16.4133 11.311 16.4133C11.6463 16.4133 11.9373 16.5328 12.1732 16.7687C12.4091 17.0045 12.5286 17.2956 12.5286 17.6309C12.5286 17.9663 12.4091 18.2573 12.1732 18.4932C11.9373 18.729 11.6463 18.8485 11.311 18.8485ZM11.311 15.7471C11.0738 15.7471 10.866 15.6582 10.6964 15.4886C10.5268 15.319 10.438 15.1113 10.438 14.8741V14.0987C10.438 13.7793 10.5183 13.4814 10.6787 13.2086C10.8391 12.936 11.0577 12.7249 11.3327 12.5794L13.94 11.2649C14.1222 11.1673 14.2738 11.0203 14.3944 10.8173C14.5136 10.6166 14.5732 10.3978 14.5732 10.1573C14.5732 9.78827 14.4481 9.48365 14.1963 9.23191C13.9446 8.98017 13.64 8.85498 13.2709 8.85498H10.7295C10.3604 8.85498 10.0558 8.98017 9.80407 9.23191C9.55233 9.48365 9.42715 9.78827 9.42715 10.1573V10.5665C9.42715 10.8037 9.33829 11.0115 9.16871 11.1811C8.99912 11.3507 8.79135 11.4395 8.55415 11.4395C8.31695 11.4395 8.10917 11.3507 7.93959 11.1811C7.77001 11.0115 7.68115 10.8037 7.68115 10.5665V10.1573C7.68115 9.31868 7.98061 8.59713 8.57495 8.00279C9.1693 7.40845 9.89085 7.10899 10.7295 7.10899H13.2709C14.1095 7.10899 14.8311 7.40845 15.4254 8.00279C16.0198 8.59713 16.3192 9.31868 16.3192 10.1573C16.3192 10.7075 16.1774 11.221 15.8948 11.6945C15.6133 12.1662 15.2357 12.5407 14.7634 12.815L12.1873 14.0923L12.1861 14.0948L12.1846 14.0981L12.184 14.0998V14.8741C12.184 15.1113 12.0951 15.319 11.9255 15.4886C11.756 15.6582 11.5482 15.7471 11.311 15.7471Z" />
    </svg>
  );
};

export const SvgMenu: React.FC = () => {
  return (
    <svg viewBox="-293 384 24 25">
      <g>
        <path d="M-271.9,391.9H-285c-0.6,0-1-0.4-1-1s0.4-1,1-1h13.1c0.6,0,1,0.4,1,1S-271.4,391.9-271.9,391.9z" />
        <path
          d="M-271.9,397.9H-285c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1h13.1c0.6,0,1,0.4,1,1
		C-270.9,397.5-271.4,397.9-271.9,397.9z"
        />
        <path d="M-271.9,403.9H-285c-0.6,0-1-0.4-1-1s0.4-1,1-1h13.1c0.6,0,1,0.4,1,1S-271.4,403.9-271.9,403.9z" />
        <path d="M-290,391.9c-0.6,0-1-0.4-1-1s0.4-1,1-1h0c0.6,0,1,0.4,1,1S-289.4,391.9-290,391.9z" />
        <path d="M-290,397.9c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1h0c0.6,0,1,0.4,1,1C-289,397.5-289.4,397.9-290,397.9z" />
        <path d="M-290,403.9c-0.6,0-1-0.4-1-1s0.4-1,1-1h0c0.6,0,1,0.4,1,1S-289.4,403.9-290,403.9z" />
      </g>
    </svg>
  );
};

export const SvgBlank: React.FC = () => {
  return (
    <svg viewBox="0 0 16 16">
      <path d="M2.58579 1.25278C2.96086 0.877706 3.46957 0.666992 4 0.666992H9.33333C9.51014 0.666992 9.67971 0.73723 9.80474 0.862254L13.8047 4.86225C13.9298 4.98728 14 5.15685 14 5.33366V13.3337C14 13.8641 13.7893 14.3728 13.4142 14.7479C13.0391 15.1229 12.5304 15.3337 12 15.3337H4C3.46957 15.3337 2.96086 15.1229 2.58579 14.7479C2.21071 14.3728 2 13.8641 2 13.3337V2.66699C2 2.13656 2.21071 1.62785 2.58579 1.25278ZM4 2.00033C3.82319 2.00033 3.65362 2.07056 3.5286 2.19559C3.40357 2.32061 3.33333 2.49018 3.33333 2.66699V13.3337C3.33333 13.5105 3.40357 13.68 3.5286 13.8051C3.65362 13.9301 3.82319 14.0003 4 14.0003H12C12.1768 14.0003 12.3464 13.9301 12.4714 13.8051C12.5964 13.68 12.6667 13.5105 12.6667 13.3337V5.6098L9.05719 2.00033H4Z" />
      <path d="M9.33268 0.666992C9.70087 0.666992 9.99935 0.965469 9.99935 1.33366V4.66699H13.3327C13.7009 4.66699 13.9993 4.96547 13.9993 5.33366C13.9993 5.70185 13.7009 6.00033 13.3327 6.00033H9.33268C8.96449 6.00033 8.66602 5.70185 8.66602 5.33366V1.33366C8.66602 0.965469 8.96449 0.666992 9.33268 0.666992Z" />
      <path d="M4.66602 8.66667C4.66602 8.29848 4.96449 8 5.33268 8H10.666C11.0342 8 11.3327 8.29848 11.3327 8.66667C11.3327 9.03486 11.0342 9.33333 10.666 9.33333H5.33268C4.96449 9.33333 4.66602 9.03486 4.66602 8.66667Z" />
      <path d="M4.66602 11.3337C4.66602 10.9655 4.96449 10.667 5.33268 10.667H10.666C11.0342 10.667 11.3327 10.9655 11.3327 11.3337C11.3327 11.7018 11.0342 12.0003 10.666 12.0003H5.33268C4.96449 12.0003 4.66602 11.7018 4.66602 11.3337Z" />
      <path d="M4.66602 5.99967C4.66602 5.63148 4.96449 5.33301 5.33268 5.33301H6.66602C7.03421 5.33301 7.33268 5.63148 7.33268 5.99967C7.33268 6.36786 7.03421 6.66634 6.66602 6.66634H5.33268C4.96449 6.66634 4.66602 6.36786 4.66602 5.99967Z" />
    </svg>
  );
};

export const SvgExit: React.FC = () => {
  return (
    <svg viewBox="0 0 16 16">
      <path d="M3.33398 2.66634C3.15717 2.66634 2.9876 2.73658 2.86258 2.8616C2.73756 2.98663 2.66732 3.1562 2.66732 3.33301V12.6663C2.66732 12.8432 2.73756 13.0127 2.86258 13.1377C2.9876 13.2628 3.15717 13.333 3.33398 13.333H6.00065C6.36884 13.333 6.66732 13.6315 6.66732 13.9997C6.66732 14.3679 6.36884 14.6663 6.00065 14.6663H3.33398C2.80355 14.6663 2.29484 14.4556 1.91977 14.0806C1.5447 13.7055 1.33398 13.1968 1.33398 12.6663V3.33301C1.33398 2.80257 1.5447 2.29387 1.91977 1.91879C2.29484 1.54372 2.80355 1.33301 3.33398 1.33301H6.00065C6.36884 1.33301 6.66732 1.63148 6.66732 1.99967C6.66732 2.36786 6.36884 2.66634 6.00065 2.66634H3.33398Z" />
      <path d="M10.1953 4.19526C10.4556 3.93491 10.8777 3.93491 11.1381 4.19526L14.4714 7.5286C14.7318 7.78894 14.7318 8.21106 14.4714 8.4714L11.1381 11.8047C10.8777 12.0651 10.4556 12.0651 10.1953 11.8047C9.93491 11.5444 9.93491 11.1223 10.1953 10.8619L13.0572 8L10.1953 5.13807C9.93491 4.87772 9.93491 4.45561 10.1953 4.19526Z" />
      <path d="M5.33398 7.99967C5.33398 7.63148 5.63246 7.33301 6.00065 7.33301H14.0007C14.3688 7.33301 14.6673 7.63148 14.6673 7.99967C14.6673 8.36786 14.3688 8.66634 14.0007 8.66634H6.00065C5.63246 8.66634 5.33398 8.36786 5.33398 7.99967Z" />
    </svg>
  );
};

export const SvgPicture: React.FC = () => {
  return (
    <svg viewBox="-293 385 24 24">
      <path d="M-274,406.5h-14c-1.4,0-2.5-1.1-2.5-2.5v-14c0-1.4,1.1-2.5,2.5-2.5h14c1.4,0,2.5,1.1,2.5,2.5v14C-271.5,405.4-272.6,406.5-274,406.5z M-288,388.5c-0.8,0-1.5,0.7-1.5,1.5v14c0,0.8,0.7,1.5,1.5,1.5h14c0.8,0,1.5-0.7,1.5-1.5v-14c0-0.8-0.7-1.5-1.5-1.5H-288z" />
      <path d="M-284.5,395.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S-283.4,395.5-284.5,395.5z M-284.5,392.5c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S-283.9,392.5-284.5,392.5z" />
      <path d="M-288,406.5c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7l11-11c0.2-0.2,0.5-0.2,0.7,0l5,5c0.2,0.2,0.2,0.5,0,0.7s-0.5,0.2-0.7,0l-4.6-4.6l-10.6,10.6C-287.7,406.5-287.9,406.5-288,406.5z" />
    </svg>
  );
};

export const SvgDownload: React.FC = () => {
  return (
    <svg viewBox="-297 389 16 16">
      <path d="M-284.3,403.5h-9.3c-0.5,0-1-0.2-1.3-0.5s-0.5-0.8-0.5-1.3V399c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v2.7c0,0.2,0.1,0.4,0.2,0.6c0.2,0.2,0.4,0.2,0.6,0.2h9.3c0.2,0,0.4-0.1,0.6-0.2s0.2-0.4,0.2-0.6V399c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v2.7c0,0.5-0.2,0.9-0.5,1.3S-283.8,403.5-284.3,403.5z" />
      <path d="M-289,399.5c-0.1,0-0.3,0-0.4-0.1l-3.3-3.3c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l3,3l3-3c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7l-3.3,3.3C-288.7,399.5-288.9,399.5-289,399.5z" />
      <path d="M-289,399.5c-0.3,0-0.5-0.2-0.5-0.5v-8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v8C-288.5,399.3-288.7,399.5-289,399.5z" />
    </svg>
  );
};

export const SvgBartWebIcon: React.FC = () => {
  return (
    <svg viewBox="0 0 2217.48 2217.26">
      <path d="m1222.82,1497.77s0,0,0,0c-134.38,0-260.72-52.33-355.74-147.35-34.6-34.6-34.6-90.7,0-125.29,34.6-34.59,90.69-34.59,125.29,0,61.56,61.56,143.4,95.46,230.45,95.46s168.89-33.9,230.44-95.46l491.58-491.58c61.56-61.56,95.46-143.4,95.46-230.45s-33.9-168.89-95.45-230.45c-61.56-61.56-143.4-95.46-230.45-95.46s-168.89,33.9-230.45,95.46l-245.79,245.79c-34.6,34.59-90.7,34.59-125.29,0-34.6-34.6-34.6-90.7,0-125.29l245.79-245.79C1453.66,52.34,1580,0,1714.39,0s260.72,52.34,355.74,147.36c95.02,95.02,147.35,221.35,147.35,355.74s-52.33,260.71-147.35,355.74l-491.58,491.58c-95.01,95.01-221.36,147.35-355.73,147.35Z" />
      <path d="m503.09,2217.26c-128.84.01-257.65-49.03-355.74-147.12C52.33,1975.12,0,1848.79,0,1714.4s52.33-260.71,147.35-355.74l491.58-491.58c95.02-95.02,221.36-147.36,355.74-147.36s260.72,52.34,355.74,147.36c34.6,34.61,34.6,90.7,0,125.29-34.6,34.61-90.69,34.59-125.29,0-61.56-61.56-143.39-95.46-230.45-95.46s-168.89,33.9-230.45,95.46l-491.58,491.58c-61.56,61.56-95.46,143.4-95.46,230.45s33.9,168.89,95.45,230.45c127.08,127.08,333.84,127.06,460.91,0l245.78-245.79c34.6-34.59,90.7-34.59,125.29,0,34.6,34.6,34.6,90.7,0,125.29l-245.79,245.79c-98.07,98.07-226.93,147.1-355.75,147.12Z" />
    </svg>
  )
}

export const SvgSave: React.FC = () => {
  return (
    <svg viewBox="0 0 24 24">
      <path d="M5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V8.41421L15.5858 4H5ZM2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H16C16.2652 2 16.5196 2.10536 16.7071 2.29289L21.7071 7.29289C21.8946 7.48043 22 7.73478 22 8V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V5C2 4.20435 2.31607 3.44129 2.87868 2.87868Z" />
      <path d="M6 13C6 12.4477 6.44772 12 7 12H17C17.5523 12 18 12.4477 18 13V21C18 21.5523 17.5523 22 17 22C16.4477 22 16 21.5523 16 21V14H8V21C8 21.5523 7.55228 22 7 22C6.44772 22 6 21.5523 6 21V13Z" />
      <path d="M7 2C7.55228 2 8 2.44772 8 3V7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H7C6.44772 9 6 8.55228 6 8V3C6 2.44772 6.44772 2 7 2Z" />
    </svg>
  );
};

export const SvgShare: React.FC = () => {
  return (
    <svg viewBox="0 0 18 22">
      <path d="M15,22H3c-0.8,0-1.6-0.3-2.1-0.9C0.3,20.6,0,19.8,0,19v-8c0-0.6,0.4-1,1-1s1,0.4,1,1v8c0,0.3,0.1,0.5,0.3,0.7 C2.5,19.9,2.7,20,3,20h12c0.3,0,0.5-0.1,0.7-0.3S16,19.3,16,19v-8c0-0.6,0.4-1,1-1s1,0.4,1,1v8c0,0.8-0.3,1.6-0.9,2.1S15.8,22,15,22 z" />
      <path d="M13,6c-0.3,0-0.5-0.1-0.7-0.3L9,2.4L5.7,5.7c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l4-4c0.4-0.4,1-0.4,1.4,0l4,4 c0.4,0.4,0.4,1,0,1.4C13.5,5.9,13.3,6,13,6z" />
      <path d="M9,15c-0.6,0-1-0.4-1-1V1c0-0.6,0.4-1,1-1s1,0.4,1,1v13C10,14.6,9.6,15,9,15z" />
    </svg>
  );
};

export const SvgDelete: React.FC = () => {
  return (
    <svg viewBox="-297 389 16 16">
      <path d="M-283,393.8h-12c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h12c0.4,0,0.8,0.3,0.8,0.8S-282.6,393.8-283,393.8z" />
      <path
        d="M-285.7,404.4h-6.7c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.6-1.5V393c0-0.4,0.3-0.8,0.8-0.8
	s0.8,0.3,0.8,0.8v9.3c0,0.2,0.1,0.3,0.2,0.4s0.3,0.2,0.4,0.2h6.7c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.4V393
	c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v9.3c0,0.6-0.2,1.1-0.6,1.5C-284.6,404.2-285.1,404.4-285.7,404.4z M-286.3,393.7
	c-0.4,0-0.8-0.3-0.8-0.8v-1.3c0-0.2-0.1-0.3-0.2-0.4s-0.3-0.2-0.4-0.2h-2.7c-0.2,0-0.3,0.1-0.4,0.2s-0.2,0.3-0.2,0.4v1.3
	c0,0.4-0.3,0.8-0.8,0.8s-0.8-0.3-0.8-0.8v-1.3c0-0.6,0.2-1.1,0.6-1.5s0.9-0.6,1.5-0.6h2.7c0.6,0,1.1,0.2,1.5,0.6s0.6,0.9,0.6,1.5
	v1.3C-285.6,393.4-285.9,393.7-286.3,393.7z"
      />
    </svg>
  );
};

export const SvgEdit: React.FC = () => {
  return (
    <svg viewBox="0 0 16 16">
      <path d="M7.33398 13.3334C7.33398 12.9652 7.63246 12.6667 8.00065 12.6667H14.0007C14.3688 12.6667 14.6673 12.9652 14.6673 13.3334C14.6673 13.7015 14.3688 14 14.0007 14H8.00065C7.63246 14 7.33398 13.7015 7.33398 13.3334Z" />
      <path d="M12.0007 2.58577C11.8024 2.58577 11.6123 2.66453 11.4721 2.80473L3.26931 11.0075L2.91691 12.4171L4.3265 12.0647L12.5293 3.86192C12.5987 3.7925 12.6537 3.71009 12.6913 3.6194C12.7289 3.5287 12.7482 3.43149 12.7482 3.33332C12.7482 3.23515 12.7289 3.13794 12.6913 3.04725C12.6537 2.95655 12.5987 2.87414 12.5293 2.80473C12.4598 2.73531 12.3774 2.68025 12.2867 2.64268C12.196 2.60511 12.0988 2.58577 12.0007 2.58577ZM10.5293 1.86192C10.9195 1.47168 11.4488 1.25244 12.0007 1.25244C12.2739 1.25244 12.5445 1.30626 12.797 1.41084C13.0494 1.51541 13.2788 1.66869 13.4721 1.86192C13.6653 2.05514 13.8186 2.28454 13.9231 2.537C14.0277 2.78947 14.0815 3.06006 14.0815 3.33332C14.0815 3.60659 14.0277 3.87718 13.9231 4.12964C13.8186 4.3821 13.6653 4.6115 13.4721 4.80473L5.13874 13.1381C5.0533 13.2235 4.94624 13.2841 4.82902 13.3134L2.16236 13.9801C1.93517 14.0369 1.69485 13.9703 1.52926 13.8047C1.36367 13.6391 1.29711 13.3988 1.3539 13.1716L2.02057 10.505C2.04988 10.3877 2.11049 10.2807 2.19593 10.1953L10.5293 1.86192Z" />
    </svg>
  );
};

export const SvgHome: React.FC<{ color?: string }> = ({ color }) => {
  return (
    <svg
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color ?? "currentColor"}
    >
      <path
        d="M12 60L60 12L108 60"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M24 108V68" strokeWidth="8" strokeLinecap="round" />
      <path d="M96 108V50" strokeWidth="8" strokeLinecap="round" />
      <path d="M24 108H96" strokeWidth="8" strokeLinecap="round" />
    </svg>
  );
};

export const SvgMarker: React.FC<{ color?: string }> = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="24"
      height="24"
      viewBox="0 0 241.000000 243.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,243.000000) scale(0.100000,-0.100000)"
        fill={color ?? "currentColor"}
        stroke="none"
      >
        <path d="M1792 2396 l-29 -25 296 -298 296 -298 29 29 c25 26 28 34 23 79 l-4 50 -245 243 -244 244 -46 0 c-35 0 -54 -6 -76 -24z" />
        <path d="M1628 2233 l-77 -78 22 -60 c30 -81 28 -79 95 -104 71 -25 86 -41 115 -117 22 -56 25 -59 81 -81 76 -29 92 -44 117 -115 12 -32 27 -62 33 -66 6 -4 39 -16 73 -28 l62 -20 76 76 75 75 -298 298 -297 297 -77 -77z" />
        <path d="M1062 1667 l-413 -413 45 -12 c60 -16 113 -63 128 -115 14 -50 44 -87 70 -87 54 0 118 -64 137 -136 11 -41 30 -57 83 -68 49 -11 96 -63 114 -123 l16 -56 414 414 c227 227 411 416 409 420 -3 4 -21 10 -40 13 -49 10 -100 58 -121 114 -23 63 -39 80 -87 93 -52 14 -102 64 -116 116 -13 47 -32 66 -84 83 -57 18 -103 63 -122 120 -9 28 -17 50 -18 50 -1 0 -188 -186 -415 -413z m545 -3 c55 -41 68 -70 68 -148 0 -63 -5 -81 -38 -149 -93 -188 -331 -344 -469 -307 -99 27 -143 116 -114 231 24 92 62 155 146 240 71 72 128 110 220 145 51 20 153 13 187 -12z" />
        <path d="M1438 1596 c-103 -37 -223 -143 -272 -241 -40 -78 -47 -164 -17 -194 16 -16 33 -21 70 -21 142 0 346 191 376 353 18 93 -53 140 -157 103z" />
        <path d="M501 1106 l-71 -71 298 -298 297 -297 75 75 74 74 -16 33 c-8 18 -19 48 -23 66 -7 36 -33 56 -83 67 -47 10 -98 62 -112 115 -16 59 -24 68 -77 82 -61 15 -109 62 -124 122 -14 55 -31 68 -110 89 l-57 15 -71 -72z" />
        <path d="M347 950 c-29 -34 -36 -85 -16 -123 16 -31 449 -465 481 -483 44 -23 93 -18 128 14 l31 27 -299 298 -299 299 -26 -32z" />
        <path d="M283 718 c-6 -7 -72 -125 -148 -261 l-138 -249 100 -100 101 -101 256 143 c141 78 258 145 261 149 2 4 -92 103 -209 220 -164 163 -215 209 -223 199z" />
      </g>
    </svg>
  );
};

export const SvgCommandDuplicate: React.FC = () => {
  return (
    <svg viewBox="0 0 18 18">
      <path d="M2.25.563h7.875A.564.564,0,0,0,10.688,0V-2.25h1.688V0a2.252,2.252,0,0,1-2.25,2.25H2.25A2.252,2.252,0,0,1,0,0V-7.875a2.252,2.252,0,0,1,2.25-2.25H4.5v1.688H2.25a.564.564,0,0,0-.562.563V0A.564.564,0,0,0,2.25.563ZM7.875-5.062H15.75a.564.564,0,0,0,.563-.562V-13.5a.564.564,0,0,0-.562-.562H7.875a.564.564,0,0,0-.562.563v7.875A.564.564,0,0,0,7.875-5.062Zm-2.25-.562V-13.5a2.252,2.252,0,0,1,2.25-2.25H15.75A2.252,2.252,0,0,1,18-13.5v7.875a2.252,2.252,0,0,1-2.25,2.25H7.875A2.252,2.252,0,0,1,5.625-5.625Z" transform="translate(0 15.75)" />
    </svg>

  )
}